/*
 * @Author: JamesWong
 * @Description: 简体中文包主入口
 * @Date: 2018-11-29 10:28:01
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-04-07 01:40:21
 */
import main from './main'
import appversion from './appversion'
import channel from './channel'
import warehouse from './warehouse'
import activeCode from './activeCode'
import account from './account'
import payment from './payment'
import screen from './screen'
import slip from './slip'
import self from './self'
import inout from './inout'
import newSlip from './newSlip'
import contract from './contract'
import note from './note'
import collaboraivePlatform from './collaboraivePlatform'
import report from './report'
import receipt from './receipt'
import home from './home'
import notice from './notice'
export default {
  main,
  home,
  receipt,
  appversion,
  channel,
  warehouse,
  activeCode,
  account,
  payment,
  screen,
  slip,
  self,
  note,
  inout,
  newSlip,
  contract,
  collaboraivePlatform,
  report,
  notice
}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/index.js